import { render, staticRenderFns } from "./uaHubIcon.vue?vue&type=template&id=0e944632&"
import script from "./uaHubIcon.vue?vue&type=script&lang=js&"
export * from "./uaHubIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports